<template>
	<div :class="productSelector">
		<div class="top">
			<div class="product--label" v-html="product.text"></div>
			<div class="product--subtitle" v-html="product.subtitle"></div>
		</div>
		<div class="bottom">
			<div v-if="product.price" class="product--footer-price">{{ product.price }}</div>
			<div v-if="product.badge" class="product--badge">{{ product.badge }}</div>
		</div>
		<div v-if="product.popular" class="product--popular">Most popular</div>
	</div>
</template>

<script>
import { computed } from 'vue'
export default {
	props: {
		product: {
			type: Object,
			required: true
		},
		isActive: {
			type: Boolean,
			required: true
		}
	},
	setup(props) {
		return {
			productSelector: computed(() => {
				const classList = ['product', props.theme]
				if (props.isActive) classList.push('active')
				if (props.product.popular) classList.push('popular')
				if (props.product.badge) classList.push('badge')
				return classList
			})
		}
	}
}
</script>

<style scoped lang="scss">
.product {
	background: #ffffff;
	border: 1px solid #e9eaf2;
	margin-bottom: 10px;
	border-radius: 0.7rem;
	transition: border-color 0.3s, background-color 0.3s, box-shadow 0.3s;
	position: relative;

	&--popular {
		font-size: 0.8rem;
		margin-left: -1px;
		margin-right: -1px;
		margin-bottom: -1px;
		background-color: #7d8bf7;
		color: #fff;
		font-weight: 500;
		padding: 0.26rem 1rem;
		text-align: center;
		border-radius: 0 0 0.7rem 0.7rem;
	}

	.old_price {
		margin-left: 4px;
	}

	&--label {
		font-weight: bold;
		font-size: 1.1rem;
		line-height: 1.3;
		text-align: center;

		::v-deep i {
			font-style: normal;
			font-weight: 400;
		}

		::v-deep .inline-badge {
			background-color: #eca58f;
			color: #fff;
			font-size: 0.7rem;
			font-weight: bold;
			padding: 0.3rem 0.6rem;
			border-radius: 0.3rem;
			display: inline-flex;
			margin-left: 3px;
			letter-spacing: 0.92px;
			position: relative;
			bottom: 2px;
		}
	}

	&--subtitle {
		margin-top: 0.8rem;
		opacity: 0.9;
		text-align: center;
		line-height: 1.2;
		font-size: 0.9rem;

		::v-deep {
			s {
				opacity: 0.6;
			}
		}
	}

	&--footer-price {
		font-size: 0.9rem;
		min-height: 1.3rem;
	}

	&--badge {
		position: absolute;
		left: 50%;
		bottom: 100%;
		transform: translate(-50%, 50%);
		background-color: #eca58f;
		color: #fff;
		font-size: 0.7rem;
		font-weight: 500;
		padding: 0.2rem 0.6rem;
		border-radius: 0.4rem;
		white-space: nowrap;
		letter-spacing: 1px;
	}

	&.active {
		border-color: #7d8bf7;
		box-shadow: inset 0 0 0 1px #7d8bf7, 0px 6px 20px rgba(0, 0, 0, 0.2);
	}

	&.primary {
		&.active {
			border-color: #7d8bf7;
		}
	}
}

.top {
	padding: 1.3rem 0.8rem 1.5rem 0.8rem;
}

.bottom {
	position: relative;
	padding: 1.2rem 1rem 1rem 1rem;
	text-align: center;
	border-top: 1px solid #e9eaf2;
}
</style>
